export default {
  data() {
    return {
      // GST must not be negative
      gst: 10,
    }
  },
  methods: {
    calculateExcludingGst(value) {
      return value / (100 + this.gst) * 100
    },
    calculateIncludingGst(value){
      return value / 100 * (100 + this.gst);
    }
  }
}